import React from 'react';
import { type ContentQueryQuery } from '@/tina/__generated__/types';
import { Blocks } from '@/app/(base)/components/blocks/blocks-renderer';

function PageContent({ data }: { data: ContentQueryQuery }): React.JSX.Element {
  return <Blocks items={data.page.blocks} />;
}

export { PageContent };
